import { render, staticRenderFns } from "./HomeCardCarousel.vue?vue&type=template&id=36824166"
import script from "./HomeCardCarousel.vue?vue&type=script&lang=js"
export * from "./HomeCardCarousel.vue?vue&type=script&lang=js"
import style0 from "./HomeCardCarousel.vue?vue&type=style&index=0&id=36824166&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports